import { useState, useEffect } from 'react'
import Nav from './components/Nav.jsx'
import IntroBanner from './components/IntroBanner.jsx'
import Sessions from './components/Sessions.jsx'
import ClassPasses from './components/ClassPasses.jsx'
import Footer from './components/Footer.jsx'

const MOCK_SESSIONS = [
  { id: '1', filter: 'flexibility',  apparatusLabel: 'Flexibility',  title: 'Small Group Flexibility Class',        date: 'Mon 21 Apr 2025', time: '10:00', durationMins: 60, price: '£17', spacesLeft: 4, isFull: false, bookingUrl: 'https://bookwhen.com', locationLine: 'Cloud Aerial Arts, Manchester', isOnline: false, applicablePasses: [{ id: 'cp-1', title: '5-Class Flexibility Pass', buyUrl: 'https://bookwhen.com' }] },
  { id: '2', filter: 'conditioning', apparatusLabel: 'Conditioning', title: 'Small Group Aerial Conditioning Class', date: 'Tue 22 Apr 2025', time: '11:00', durationMins: 60, price: '£17', spacesLeft: 3, isFull: false, bookingUrl: 'https://bookwhen.com', locationLine: 'Cloud Aerial Arts, Manchester', isOnline: false, applicablePasses: [{ id: 'cp-2', title: '5-Class Conditioning Pass', buyUrl: 'https://bookwhen.com' }] },
  { id: '3', filter: 'aerial-1to1',  apparatusLabel: 'Aerial 1:1',   title: 'Private 1:1 Aerial Coaching',          date: 'Wed 23 Apr 2025', time: '14:00', durationMins: 60, price: '£65', spacesLeft: 1, isFull: false, bookingUrl: 'https://bookwhen.com', locationLine: 'Google Meet', isOnline: true,  applicablePasses: [] },
  { id: '4', filter: 'aerial-2to1',  apparatusLabel: 'Aerial 2:1',   title: 'Private 2:1 Aerial Coaching',          date: 'Thu 24 Apr 2025', time: '10:30', durationMins: 60, price: '£45', spacesLeft: 1, isFull: false, bookingUrl: 'https://bookwhen.com', locationLine: 'Cloud Aerial Arts, Manchester', isOnline: false, applicablePasses: [] },
  { id: '5', filter: 'flexibility',  apparatusLabel: 'Flexibility',  title: 'Small Group Flexibility Class',        date: 'Sat 26 Apr 2025', time: '09:00', durationMins: 60, price: '£17', spacesLeft: 2, isFull: false, bookingUrl: 'https://bookwhen.com', locationLine: 'Cloud Aerial Arts, Manchester', isOnline: false, applicablePasses: [{ id: 'cp-1', title: '5-Class Flexibility Pass', buyUrl: 'https://bookwhen.com' }] },
  { id: '6', filter: 'aerial-1to1',  apparatusLabel: 'Aerial 1:1',   title: 'Private 1:1 Aerial Coaching',          date: 'Mon 28 Apr 2025', time: '13:00', durationMins: 60, price: '£65', spacesLeft: 1, isFull: false, bookingUrl: 'https://bookwhen.com', locationLine: 'Google Meet', isOnline: true,  applicablePasses: [] },
  { id: '7', filter: 'conditioning', apparatusLabel: 'Conditioning', title: 'Small Group Aerial Conditioning Class', date: 'Tue 29 Apr 2025', time: '15:00', durationMins: 60, price: '£17', spacesLeft: 5, isFull: false, bookingUrl: 'https://bookwhen.com', locationLine: 'Cloud Aerial Arts, Manchester', isOnline: false, applicablePasses: [{ id: 'cp-2', title: '5-Class Conditioning Pass', buyUrl: 'https://bookwhen.com' }] },
  { id: '8', filter: 'aerial-2to1',  apparatusLabel: 'Aerial 2:1',   title: 'Private 2:1 Aerial Coaching',          date: 'Wed 30 Apr 2025', time: '10:00', durationMins: 60, price: '£45', spacesLeft: 1, isFull: true,  bookingUrl: 'https://bookwhen.com', locationLine: 'Cloud Aerial Arts, Manchester', isOnline: false, applicablePasses: [] },
]

const MOCK_PASSES = [
  { id: 'cp-1', title: '5-Class Flexibility Pass', description: 'Five drop-in flexibility classes to use at any time.', price: '£75', credits: 5, validDays: 90, buyUrl: 'https://bookwhen.com' },
  { id: 'cp-2', title: '5-Class Conditioning Pass', description: 'Five aerial conditioning classes to use at any time.', price: '£75', credits: 5, validDays: 90, buyUrl: 'https://bookwhen.com' },
]

export default function App() {
  const [sessions, setSessions]     = useState([])
  const [classPasses, setClassPasses] = useState([])
  const [loading, setLoading]       = useState(true)
  const [error, setError]           = useState(null)

  useEffect(() => {
    fetch('/.netlify/functions/sessions')
      .then(r => { if (!r.ok) throw new Error(`HTTP ${r.status}`); return r.json() })
      .then(data => {
        const s = data.sessions   || []
        const p = data.classPasses || []
        if (import.meta.env.DEV && s.length === 0) {
          setSessions(MOCK_SESSIONS)
          setClassPasses(MOCK_PASSES)
        } else {
          setSessions(s)
          setClassPasses(p)
        }
        setLoading(false)
      })
      .catch(() => {
        if (import.meta.env.DEV) {
          setSessions(MOCK_SESSIONS)
          setClassPasses(MOCK_PASSES)
        } else {
          setError('Could not load sessions. Please try again shortly.')
        }
        setLoading(false)
      })
  }, [])

  return (
    <>
      <Nav />
      <Sessions sessions={sessions} passes={classPasses} loading={loading} error={error} />
      <ClassPasses passes={classPasses} />
      <Footer />
      <IntroBanner />
    </>
  )
}
